module.exports = __webpack_public_path__ + "media/images/flags/om-ce7832698163e15c9f1ba01857184818.svg";